const IMG = "https://static.prod-images.emergentagent.com/jobs/2e2c8d24-ff50-4566-a5f9-c44254d67a16/images/";
const VID = "https://videos.pexels.com/video-files/";

export const IMAGES = {
  heroCoils: `${IMG}658bdae0e211ffc29c15cf79631ea69a36a996c12a42e8c0355cdbf6a61f954a.jpeg`,
  moltenSteel: `${IMG}8e895d0d06de3b22f7ff13def1a778fd6300c976784ef2a41a62e3e24bc4f500.jpeg`,
  truck: `${IMG}f520ad9df95c8a764e53c5505c01092c76fa1ca849ed028eaf0d0fe0bd66987d.jpeg`,
  tmtYard: `${IMG}e9bfc721d7e8c443d688e191858fe0b4f5f939d667d5ec555775b072fd7e1bbc.jpeg`,
};

const CATEGORY_IMAGES = {
  "HR Coil": `${IMG}6587a47efeaac81812e6390c5c4ff05ccaa4239355762269f26b6598400cbf52.jpeg`,
  "CR Coil": `${IMG}df04bb9f116879cfd0deb9965f4418b46222a362231a60b6090e51b52b792e33.jpeg`,
  "SS Coil": `${IMG}df04bb9f116879cfd0deb9965f4418b46222a362231a60b6090e51b52b792e33.jpeg`,
  "GP Coil": `${IMG}5e726e8bbb82d1a6f9b39f4ce05c76c2feca166419b695d93417fad8a9ac7364.jpeg`,
  "GP Sheet": `${IMG}5e726e8bbb82d1a6f9b39f4ce05c76c2feca166419b695d93417fad8a9ac7364.jpeg`,
  "GI Sheet": `${IMG}5e726e8bbb82d1a6f9b39f4ce05c76c2feca166419b695d93417fad8a9ac7364.jpeg`,
  "PPGI Sheet": `${IMG}5e726e8bbb82d1a6f9b39f4ce05c76c2feca166419b695d93417fad8a9ac7364.jpeg`,
  "HR Sheet": `${IMG}945378d2739ca0e75f2a3ca84eca5456b9ab25645dd5fbf4aff30d040b2c78ee.jpeg`,
  "CR Sheet": `${IMG}5c9240b8265043ec111dd0e5bd62da4a76f97ba5e14ca593e161c4d28f78bdf5.jpeg`,
  "SS Sheet": `${IMG}5c9240b8265043ec111dd0e5bd62da4a76f97ba5e14ca593e161c4d28f78bdf5.jpeg`,
  "TMT Bar": `${IMG}6aaecbde21d64d22e4146f1ec93bf142f5a6cc125b19a11fdf80fb72930b2b9a.jpeg`,
  "GI Wire": `${IMG}6aaecbde21d64d22e4146f1ec93bf142f5a6cc125b19a11fdf80fb72930b2b9a.jpeg`,
  Billet: `${IMG}aa0423f22902b6a59c03ca72915cdaae25d83e79c8c8e1f4cd0d9b3fe8e839c1.jpeg`,
  "GI Pipe": `${IMG}cfe5b76c7d5e04e71e47edf45effba4ca7a1656eeab639542112cd771da28c72.jpeg`,
  "MS Plate": `${IMG}945378d2739ca0e75f2a3ca84eca5456b9ab25645dd5fbf4aff30d040b2c78ee.jpeg`,
  "MS Angle": `${IMG}945378d2739ca0e75f2a3ca84eca5456b9ab25645dd5fbf4aff30d040b2c78ee.jpeg`,
  "MS Channel": `${IMG}945378d2739ca0e75f2a3ca84eca5456b9ab25645dd5fbf4aff30d040b2c78ee.jpeg`,
};

export const productImage = (category = "") => {
  if (CATEGORY_IMAGES[category]) return CATEGORY_IMAGES[category];
  const c = category.toLowerCase();
  if (c.includes("coil")) return CATEGORY_IMAGES["HR Coil"];
  if (c.includes("pipe") || c.includes("tube")) return CATEGORY_IMAGES["GI Pipe"];
  if (c.includes("tmt") || c.includes("bar") || c.includes("wire") || c.includes("rebar")) return CATEGORY_IMAGES["TMT Bar"];
  if (c.includes("sheet")) return CATEGORY_IMAGES["GP Sheet"];
  if (c.includes("billet")) return CATEGORY_IMAGES.Billet;
  return CATEGORY_IMAGES["MS Plate"];
};

const poster = (id) => `https://images.pexels.com/videos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=1280`;
export const VIDEOS = [
  { id: "molten", title: "Molten steel pour", caption: "From furnace to billet — where every ironByte order begins", src: `${VID}5121752/5121752-hd_1280_720_25fps.mp4`, poster: poster(5121752) },
  { id: "furnace", title: "Furnace tapping", caption: "Verified mills, certificate-backed heats", src: `${VID}5121741/5121741-hd_1280_720_25fps.mp4`, poster: poster(5121741) },
  { id: "casting", title: "Continuous casting", caption: "Live rates tracked from plant to yard", src: `${VID}5121701/5121701-hd_1280_720_25fps.mp4`, poster: poster(5121701) },
  { id: "plant", title: "Heavy industry floor", caption: "Nationwide supplier network, one platform", src: `${VID}6997690/6997690-hd_1280_720_25fps.mp4`, poster: poster(6997690) },
  { id: "sparks", title: "Furnace sparks", caption: "Quality you can see — test certificates on every lot", src: `${VID}6997856/6997856-sd_640_360_25fps.mp4`, poster: poster(6997856) },
];
export const HERO_VIDEO_LIGHT = "/media/hero-light-indian3.mp4";
export const HERO_POSTER_LIGHT = `${IMG}4d6ad37bff319e8f9ef7a4d500146e720f04ca966181043f6cd7e9eb6020c73b.jpeg`;
export const HERO_VIDEO = `${VID}6997856/6997856-sd_640_360_25fps.mp4`;
export const HERO_POSTER_DARK = IMAGES.heroCoils;
